import styled from 'styled-components';
import { media } from 'styles/utils';
import { Link } from 'core/routing';
import { Heading } from 'components';

export const Container = styled.section`
  max-width: ${props => `calc(${props.theme.layout.maxWidth} / 2)`};
  padding: ${props => props.theme.layout.paddingInline};
  margin: 0 auto;
  & + & {
    padding-top: 0;
  }

  ${props =>
    props.center &&
    `
    display: flex;
    justify-content: center;
    align-items: center;
  `}

  ${media.large`
    padding: ${props => props.theme.layout.paddingInline} 0;
  `}
`;

export const HeadingStyled = styled(Heading)`
  margin-bottom: ${props => props.theme.spacing.medium};
  &:not(:first-of-type) {
    margin-top: ${props => props.theme.spacing.medium};
  }
`;

export const StyledLink = styled(Link)`
  color: ${props => props.theme.color.primary};
  display: inline-block;
  margin-bottom: ${props => props.theme.spacing.default};
  &:hover {
    text-decoration: underline;
  }
`;

export const ImageStyled = styled.img`
  max-width: 100%;
  margin-bottom: ${props => props.theme.spacing.medium};
`;
